export default [
  {
    path: '/freeActivity', name: 'freeActivity', component: () => import('@/pages/promotions/freeActivity'), meta: { title: '营销活动设置' },
  },
  {
    path: '/freeActivityDetail', name: 'freeActivityDetail', component: () => import('@/pages/promotions/freeActivityDetail'), meta: { title: '新建' },
  },
  {
    path: '/freeActivityOrder', name: 'freeActivityOrder', component: () => import('@/pages/promotions/freeActivityOrder'), meta: { title: '免费活动明细' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/promotions.js